import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

import { format, useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import { computed } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogMessage',
  props: {
  modelValue: {
    type: Boolean,
    default: undefined,
  },

  title: {
    type: String,
  },

  content: {
    type: String,
  },

  html: {
    type: Boolean,
    default: false,
  },

  persistent: {
    type: Boolean,
    default: false,
  },

  buttonText: {
    type: String,
    default: () => {
      const { t } = useI18n()
      return format.capitalize(t("sfxButtons.btn_ok"))
    },
  },

  closeIcon: {
    type: String,
  },
},
  emits: [...useDialogPluginComponent.emits, "update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const model = computed({
  get() {
    return props.modelValue
  },

  set(value) {
    return emit("update:modelValue", value)
  },
})

const { dialogRef, onDialogHide, onDialogOK } = useDialogPluginComponent()

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide),
    persistent: props.persistent,
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          (props.title)
            ? (_openBlock(), _createBlock(_component_q_card_section, {
                key: 0,
                class: "q-dialog__title row items-center text-h3 q-pb-xs"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.title) + " ", 1),
                  (props.closeIcon)
                    ? (_openBlock(), _createBlock(_component_q_space, { key: 0 }))
                    : _createCommentVNode("", true),
                  (props.closeIcon)
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_icon, {
                        key: 1,
                        name: props.closeIcon,
                        size: "24px"
                      }, null, 8, ["name"])), [
                        [_directive_close_popup]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (props.content)
            ? (_openBlock(), _createBlock(_component_q_card_section, {
                key: 1,
                class: "text-body1 sfx-message-content"
              }, {
                default: _withCtx(() => [
                  (props.html)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        innerHTML: props.content
                      }, null, 8, _hoisted_1))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(props.content), 1)
                      ], 64))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(SfxBtn, {
                onClick: _unref(onDialogOK),
                label: props.buttonText,
                class: "col-grow"
              }, null, 8, ["onClick", "label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide", "persistent", "modelValue"]))
}
}

})